import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="fixed bottom-6 right-6 z-200 flex flex-col gap-3 max-w-md w-full px-4 pointer-events-none">
      @for (toast of toastService.toasts(); track toast.id) {
        <div
          class="relative overflow-hidden pointer-events-auto flex items-center justify-between gap-3 rounded-xl p-4 shadow-2xl backdrop-blur-md border transition-all duration-300 animate-in slide-in-from-bottom-5"
          [class.bg-red-950\/90]="toast.type === 'error'"
          [class.border-red-600\/50]="toast.type === 'error'"
          [class.text-red-100]="toast.type === 'error'"
          [class.bg-emerald-950\/90]="toast.type === 'success'"
          [class.border-emerald-600\/50]="toast.type === 'success'"
          [class.text-emerald-100]="toast.type === 'success'"
          [class.bg-slate-900\/95]="toast.type === 'info'"
          [class.border-slate-700]="toast.type === 'info'"
          [class.text-slate-100]="toast.type === 'info'"
          role="alert"
        >
          <div class="flex items-center gap-3 min-w-0">
            @if (toast.type === 'error') {
              <div class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-red-500/20 text-red-400">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="12" y1="8" x2="12" y2="12"/>
                  <line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
              </div>
            } @else if (toast.type === 'success') {
              <div class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-emerald-500/20 text-emerald-400">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                  <polyline points="22 4 12 14.01 9 11.01"/>
                </svg>
              </div>
            } @else {
              <div class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white/20 text-white">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="12" y1="16" x2="12" y2="12"/>
                  <line x1="12" y1="8" x2="12.01" y2="8"/>
                </svg>
              </div>
            }
            <p class="text-sm font-medium leading-snug wrap-break-word">
              {{ toast.message }}
            </p>
          </div>
          <button
            type="button"
            (click)="toastService.remove(toast.id)"
            class="shrink-0 rounded-lg p-1 text-slate-400 hover:text-white transition-colors"
            aria-label="Close notification"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>

          @if (toast.duration && toast.duration > 0) {
            <div
              class="absolute bottom-0 left-0 h-0.5 w-full animate-toast-progress"
              [class.bg-red-500]="toast.type === 'error'"
              [class.bg-emerald-500]="toast.type === 'success'"
              [class.bg-white]="toast.type === 'info'"
              [style.animationDuration.ms]="toast.duration"
            ></div>
          }
        </div>
      }
    </div>
  `,
  styles: [`
    @keyframes toastProgress {
      from {
        width: 100%;
      }
      to {
        width: 0%;
      }
    }
    .animate-toast-progress {
      animation-name: toastProgress;
      animation-timing-function: linear;
      animation-fill-mode: forwards;
    }
  `]
})
export class ToastComponent {
  toastService = inject(ToastService);
}
